export const FOOTER_LINKS_SECTIONS = [
  {
    text: 'O nás',
    location: 'https://www.economia.cz/project/o-nas'
  },
  {
    text: 'Všechny služby',
    location: '/sluzby/'
  },
  {
    text: 'Volná místa',
    location: 'http://economia.jobs.cz/'
  },
  {
    text: 'Služby firmám',
    location: '/agentura-najisto/'
  },
  {
    text: 'Všeobecné podmínky',
    location: 'http://economia.ihned.cz/vseobecne-smluvni-podminky/'
  },
  {
    text: 'Cookies',
    location: 'http://economia.ihned.cz/cookies/'
  },
  {
    text: 'Ochrana osobních údajů',
    location: 'http://economia.ihned.cz/zasady-ochrany-osobnich-udaju/'
  },
  {
    text: 'Nápověda',
    location: 'http://napoveda.centrum.cz/'
  }
]

export const FOOTER_LINKS_SITES = [
  {
    text: 'Centrum.cz',
    location: 'https://www.centrum.cz/'
  },
  {
    text: 'Atlas.cz',
    location: 'https://atlas.centrum.cz/'
  },
  {
    text: 'Volny.cz',
    location: 'https://www.volny.cz/'
  }
]
